
<!-- appel de la barre selecteur questionnaire : elements qui permettent d'identifier un questionnaire -->
<bis-selecteur-questionnaire *ngIf="rolesService.isHabilite(['gestionnaire']) && formulaireSelecteur"
    [formulaireSelecteur]="formulaireSelecteur" [noCmpstAffiche]="noCmpstAffiche"
    (reinitialiser)="reinitialiserChampNoCmpst()" (charger)="chargerQuestionnaireViaNoCmpst()">
</bis-selecteur-questionnaire>

<!-- Affichage pour l'enquêté en mode consultation -->
<div class="form-row pb-5" *ngIf="(! rolesService.isHabilite(['gestionnaire'])) && (modeRendu.enModeConsultation$ | async) && ! (modeRendu.enModeImpression$ | async)">
    <div class="form-row bandeau-consultation">
        <div class="col-md-12">
            <I><B>
                Votre questionnaire est en mode consultation car la date limite de saisie en ligne est dépassée.<br>
                Si vous souhaitez apporter des modifications, contactez le SSER. 
            </B></I>        
        </div>
    </div>
</div>

<!-- Questionnaire -->
<div *ngIf="rootForm && ! (modeRendu.enModeImpression$ | async)">
    <!-- Composant qui affiche les boutons : ici que sauvegarder -->
    <bis-boutons-questionnaire [simple]="true" [export]="true" (reinitialisationNoCmpst)="reinitialiserChampNoCmpst($event)"></bis-boutons-questionnaire>
    
    <!-- Dans le cas de la saisie on fait apparaitre des onglets-->
    <div class="onglets" *ngIf="rootForm && ! (modeRendu.enModeImpression$ | async)">
        <mat-tab-group id="tab" color="" *ngIf="rootForm" [(selectedIndex)]="index" (selectedTabChange)="clickTab($event)">
            <mat-tab label="DG">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('dg').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('dg') | async) && !rootForm.get('dg').invalid
                            }">DG - Données générales</span>
                    </div>
                </ng-template>
                <bis-donnees-generales></bis-donnees-generales>
            </mat-tab>

            <mat-tab label="Moyens">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('moyens').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('moyens') | async) && !rootForm.get('moyens').invalid
                            }">A - Les moyens</span>
                    </div>
                </ng-template>
                <bis-moyens></bis-moyens>
            </mat-tab>

            <mat-tab label="PremiersContacts">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('premiersContacts').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('premiersContacts') | async) && !rootForm.get('premiersContacts').invalid
                            }">B - Les premiers contacts</span>
                    </div>
                </ng-template>
                <bis-premiers-contacts></bis-premiers-contacts>
            </mat-tab>

            <mat-tab label="PersonnesRecues">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('personnesRecues').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('personnesRecues') | async) && !rootForm.get('personnesRecues').invalid
                            }">C - Les personnes reçues</span>
                    </div>
                </ng-template>
                <bis-personnes-recues></bis-personnes-recues>
            </mat-tab>

            <mat-tab label="FaitsProcedure">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('contexteFaitsProcedure').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('contexteFaitsProcedure') | async) && !rootForm.get('contexteFaitsProcedure').invalid
                            }">D - Les faits - procédure</span>
                    </div>
                </ng-template>
                <bis-contexte-faits-procedure></bis-contexte-faits-procedure>
            </mat-tab>

            <mat-tab label="AidesApportees">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('aidesApportees').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('aidesApportees') | async) && !rootForm.get('aidesApportees').invalid
                            }">E - Les aides apportées</span>
                    </div>
                </ng-template>
                <bis-aides-apportees></bis-aides-apportees>
            </mat-tab>

            <mat-tab label="Bav" *ngIf="filtreService.isNotBav()===false">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('bav').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('bav') | async) && !rootForm.get('bav').invalid
                            }">F - Activité des BAV</span>
                    </div>
                </ng-template>
                <bis-bav></bis-bav>
            </mat-tab>

            <mat-tab label="SyntheseBav" *ngIf="filtreService.isNotBav()===false">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span [ngClass]="{
                            'onglet-invalide': rootForm.get('syntheseBav').invalid,
                            'onglet-alerte': (alertesService.aAlerte$.get('syntheseBav') | async) && !rootForm.get('syntheseBav').invalid
                            }">G - Synthèse BAV</span>
                    </div>
                </ng-template>
                <bis-synthese-bav></bis-synthese-bav>
            </mat-tab>

            <mat-tab label="Comment">
                <ng-template mat-tab-label>
                    <div class="onglet">
                        <span
                            [ngClass]="{'presence-commentaire': rootForm.get('commentaire').value && rootForm.get('commentaire').value.length > 0}">
                            Commentaire
                        </span>
                    </div>
                </ng-template>
                <div class="body">
                  <div class="col-12">
                    <div class="form-row">
                        <div class='comment col-12 pt-3'>
                            <div class="col-md-12">
                                <bis-textarea-input libelle="Remarques (1000 caractères maximum) : n'hésitez pas à justifier les réponses remplies précédemment" label="commentaire"
                                    longueurMax=1000 textSaisie="Saisir le commentaire">
                                </bis-textarea-input>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <!-- Boutons onglet précédent et suivant -->
    <div class="form-row py-2 mt-3" *ngIf="! (modeRendu.enModeImpression$ | async)">
        <button class="col-2 ml-auto btn btn-enq btn-secondary mx-1" tabindex="-1"
            (click)="ongletPrecedent()" title="Onglet précédent..."><i class="material-icons md-18 mr-1"
                aria-hidden="true">skip_previous</i> Précédent</button>
        <button class="col-2 btn btn-enq btn-secondary mx-1" tabindex="0"
            (click)="ongletSuivant()" title="Onglet suivant...">
            <i class="material-icons md-18 mr-1" aria-hidden="true">skip_next</i> Suivant</button>
    </div>

    <!-- Composant qui affiche les boutons : ici supprimer, sauvegarder, valider -->
    <bis-boutons-questionnaire (reinitialisationNoCmpst)="reinitialiserChampNoCmpst($event)"></bis-boutons-questionnaire>
    <br />
    <br />
    <br />
    <!-- affichage json -->
    <div *ngIf="isDev && rootForm">
        <pre *ngIf="rootForm">
            {{ rootForm.value | json }}
        </pre>
        <pre *ngIf="rootForm">
            {{ rootForm.getRawValue() | json }}
        </pre>

        <pre *ngIf="rootForm">
            {{ rootForm.errors | json}}
        </pre>
    </div>
</div>

<!-- Impression -->
<div *ngIf="rootForm && (modeRendu.enModeImpression$ | async)">
    <span [ngClass]="{
        'onglet-invalide': rootForm.get('dg').invalid,
        'onglet-alerte': (alertesService.aAlerte$.get('dg') | async) && !rootForm.get('dg').invalid
            }">DG - Données générales
    </span>
    <bis-donnees-generales></bis-donnees-generales>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('moyens').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('moyens') | async) && !rootForm.get('moyens').invalid
            }">A - Les moyens
        </span>
    </h2>
    <bis-moyens></bis-moyens>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('premiersContacts').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('premiersContacts') | async) && !rootForm.get('premiersContacts').invalid
            }">B - Les premiers contacts
        </span>
    </h2>
    <bis-premiers-contacts></bis-premiers-contacts>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('personnesRecues').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('personnesRecues') | async) && !rootForm.get('personnesRecues').invalid
            }">C - Les personnes reçues
        </span>
    </h2>
    <bis-personnes-recues></bis-personnes-recues>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('contexteFaitsProcedure').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('contexteFaitsProcedure') | async) && !rootForm.get('contexteFaitsProcedure').invalid
            }">D - Les faits - procédure
        </span>
    </h2>
    <bis-contexte-faits-procedure></bis-contexte-faits-procedure>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('aidesApportees').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('aidesApportees') | async) && !rootForm.get('aidesApportees').invalid
            }">E - Les aides apportées
        </span>
    </h2>
    <bis-aides-apportees></bis-aides-apportees>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('bav').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('bav') | async) && !rootForm.get('bav').invalid
            }">F - Activité des BAV
        </span>
    </h2>
    <bis-bav></bis-bav>
    <br>
    <br>
    <h2 style="page-break-before: always">
        <span [ngClass]="{
            'onglet-invalide': rootForm.get('syntheseBav').invalid,
            'onglet-alerte': (alertesService.aAlerte$.get('syntheseBav') | async) && !rootForm.get('syntheseBav').invalid
            }">G - Synthèse BAV
        </span>
    </h2>
    <bis-synthese-bav></bis-synthese-bav>
    <br>
    <br>
    <br>
    <div style="page-break-before: always"></div>
    <div class="col-12">
        <h2>Commentaire</h2>
        <div class="row">
            <div class='comment col-12 pt-3'>
                <div class="col-md-12">
                    <bis-textarea-input libelle="Remarques (1000 caractères maximum) : n'hésitez pas à justifier les réponses remplies précédemment" label="commentaire" longueurMax=1000
                        textSaisie="Saisir le commentaire">
                    </bis-textarea-input>
                </div>
            </div>
        </div>
    </div>
</div>